import React, { Component } from 'react';
import './Debit.scss';
import PaymentChooser from '../PaymentChooser/PaymentChooser';
import parameterService from '../../services/parameterService';
import paymentService from '../../services/paymentService';
import languageService from '../../services/languageService';
import config from '../../data/config';
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import NameInput from '../NameInput';
import IbanInput from './IbanInput';

class Debit extends Component {
    constructor(props) {
        super(props);
        this.onPaymentMeanChange = props.onPaymentMeanChange instanceof Function ? props.onPaymentMeanChange : null;
        this.state = {
            accountOwner: '',
            iban: '',
            iban_valid: false
        };

        this.credentialsAreValid = this.credentialsAreValid.bind(this);
    }

    /**
     * Method which validates the entered data
     * @returns boolean
     */
    credentialsAreValid() {
        const { accountOwner, iban_valid } = this.state;

        return accountOwner.length >=3 && iban_valid;
    }

    /**
     * Trigger payment
     * @param event
     */
    onPaymentRequest = event => {
        event.preventDefault();
        const { accountOwner, iban } = this.state;


        if (!this.credentialsAreValid()) {
            console.log('pay now exception');
            return;
        }

        event.target.disabled = true;
        paymentService.directDebitPayment({ accountOwner, iban });
    };

    componentDidMount() {
        document.getElementById('debitOwnerName').focus();
    };

    render() {
        return (
            <div className="row">
                <div className="Debit">
                    <form className="debit-container debit-form" onSubmit={this.onPaymentRequest}>
                        <h2 className="headline">
                            {languageService.texts.pleaseEnterDebit}
                        </h2>
                        <div className="mt-4 d-flex justify-content-start align-items-center flex-wrap">
                            <div className="payment-logo selected mr-4">
                                <img src={config.imageUrl + 'edd.png'} alt="EC"/>
                            </div>
                            <div className="my-3">
                                {languageService.texts.paymentMethod} <span
                                className="d-block font-weight-bold">{languageService.texts.debit}</span>
                            </div>
                        </div>
                        <ErrorMessage/>
                        <div className="form-group my-4">
                            <NameInput id="debitOwnerName" placeholder={languageService.texts.ownerName}
                                       onChange={accountOwner => {
                                           this.setState({ accountOwner });
                                       }}/>
                        </div>
                        <div className="form-group">
                            <IbanInput id="debitIban" placeholder={languageService.texts.iban}
                                       onChange={payload => {
                                           const { value, isValid } = payload;

                                           this.setState({
                                               iban: value,
                                               iban_valid: isValid
                                           });
                                       }}/>
                        </div>
                        <div className="text-right pt-1">
                            <button
                                type="submit"
                                className="pay-btn btn btn-primary btn-block"
                                disabled={!this.credentialsAreValid()}>
                                {languageService.texts.pay} {parameterService.data.amount && parameterService.data.amount + ' '} {languageService.texts.now}
                            </button>
                        </div>
                    </form>
                    {this.onPaymentMeanChange instanceof Function &&
                    <PaymentChooser onPaymentMeanChange={this.onPaymentMeanChange} excludes={['debit', 'googlepay', 'applepay']}/>}
                </div>
            </div>
        );
    }
}

export default Debit;



// WEBPACK FOOTER //
// ./src/components/Debit/Debit.js